import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  errors,
  IRideUpdateResultDto,
  RideSoftValidationErrorResponse,
  SimpleResult,
} from "@ryde/shared";

import { IRideDragData } from "./drag-handlers.models";
import { useDragRidesPassengers } from "./use-drag-rides-passengers";
import { useRideIsDroppable } from "./use-ride-is-droppable";

export const useDragRideToRide = () => {
  const { t } = useTranslation();
  const { dropPassengersToRide } = useDragRidesPassengers();
  const { isRideDroppable } = useRideIsDroppable();
  const dragRideToRide = useEvent(
    async (
      dragDropDataParams: IRideDragData,
    ): Promise<
      SimpleResult<
        IRideUpdateResultDto | RideSoftValidationErrorResponse | undefined
      >
    > => {
      const { dragSource, dropTarget } = dragDropDataParams;
      const dragRideDto = dragSource.payload.rideDto;
      const dropRideDto = dropTarget.rideDrop;

      if (!dropRideDto) {
        return new SimpleResult({ error: t(errors.ride.invalidDropRide) });
      }

      const checkResult = isRideDroppable(dragDropDataParams);

      if (!checkResult.success) {
        return checkResult as SimpleResult<undefined>;
      }

      const passengerInfos = dragRideDto?.metadata?.passengersInfo;

      if (!dragRideDto?.id || !dropRideDto.id) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragDropRideData),
        });
      }

      if (!passengerInfos?.length) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragDropRideDataNoPassengersToDrop),
        });
      }

      return dropPassengersToRide(
        [...passengerInfos],
        dragRideDto,
        dropRideDto,
      );
    },
  );

  return { dragRideToRide };
};
